// Lib
import React, { useCallback, useEffect } from 'react';
import CommentThreadContainer from '../CommentThreadContainer';
import { useDispatch } from 'react-redux';
import { finishEditingCollapsedCommentThread } from './commentThreadCollapsedActions';

type CommentThreadCollapsedPopupContent = {
    elementId: string;
    threadId: string;
    // TODO - There would be a lot more - this isn't exhaustive!
};

/**
 * Wraps the CommentThreadContainer to provide keyboard handling that will stop editing
 * the comment when the popup is closed.
 */
const CommentThreadCollapsedPopupContent: React.FC<CommentThreadCollapsedPopupContent> = (props) => {
    const { elementId, threadId } = props;

    const dispatch = useDispatch();
    const dispatchFinishEditingCollapsedCommentThread = useCallback(
        () => dispatch(finishEditingCollapsedCommentThread({ elementId, threadId })),
        [],
    );

    // On close, stop editing this comment thread
    useEffect(
        () => () => {
            dispatchFinishEditingCollapsedCommentThread();
        },
        [],
    );

    return <CommentThreadContainer {...props} isCollapsedThread disableCollapse />;
};

export default CommentThreadCollapsedPopupContent;
